import React, { useState } from "react";
import type { FC } from "react";
import {
  Box, Button, TextField, Typography,
} from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { login } from "../../services/request";

type Props = {
  onNext: ({expires, token}: { expires: number, token: string }) => void,
}

const useStyles = makeStyles((theme) => ({
  input: {
    paddingBottom: theme.spacing(2),
  },
}));

const AuthField: FC<Props> = ({ onNext }: Props) => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    login: "",
    password: "",
  });
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((data) => ({ ...data, [name]: value }));
    setErrorMessage("");
  };

  const onKeyPress = ({ charCode }: { charCode: number }) => {
    const enterCharCode: number = 13;
    if (charCode === enterCharCode) {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    login(formData).then((r: any) => {
      onNext(r.data.payload);
    }).catch((r: any) => {
      const message: string = (r && r.response && r.response.data && r.response.data.message) || "Error";
      setErrorMessage(message);
      setLoading(false);
    });
  };

  return (
    <Box onKeyPress={onKeyPress}>
      <Typography variant="body2">
        User Name
      </Typography>
      <TextField
        variant="outlined"
        margin="dense"
        required
        fullWidth
        autoFocus
        placeholder="Input your User Name"
        size="small"
        type="text"
        name="login"
        value={formData.login}
        onChange={handleChange}
        className={classes.input}
        error={Boolean(errorMessage)}
        data-testid="login"
      />
      <Typography variant="body2">
        Password
      </Typography>
      <TextField
        variant="outlined"
        margin="dense"
        required
        fullWidth
        size="small"
        placeholder="Input your password"
        type="password"
        name="password"
        value={formData.password}
        onChange={handleChange}
        className={classes.input}
        error={Boolean(errorMessage)}
        helperText={errorMessage}
        data-testid="password"
      />
      <Button
        fullWidth
        variant="contained"
        color="primary"
        name="next"
        onClick={handleSubmit}
        endIcon={<KeyboardArrowRight />}
        disabled={loading}
        data-testid="button-next"
      >
        <Box width="100%">Next</Box>
      </Button>
    </Box>
  );
};

export default AuthField;
